// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: 'AIzaSyDUCWd8AIan2DsYHQHk1onpf0xwYCMEOv4',
  authDomain: 'pockets-app-cd20d.firebaseapp.com',
  databaseURL: 'https://pockets-app-cd20d.firebaseio.com',
  projectId: 'pockets-app-cd20d',
  storageBucket: 'pockets-app-cd20d.appspot.com',
  messagingSenderId: '463560942999',
  appId: '1:463560942999:web:d76d6e9ced52b5655450d2',
};

export const config = {
  apiURL: 'https://app.grupobeh.com',
  // apiURL: 'https://sandbox.grupobeh.com',
  appID: 3
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
